import Web3 from "web3";
import { ethers } from 'ethers';

import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
// import Fortmatic from "fortmatic";
// import Authereum from "authereum";
// import BurnerConnectProvider from "@burner-wallet/burner-connect-provider";

import Onboard from 'bnc-onboard'
//import TransportWebUSB from "@ledgerhq/hw-transport-webusb";
import TransportU2F from "@ledgerhq/hw-transport-u2f";

import Notify from "bnc-notify"

import config from '@/constants/config'
import { getNowTimestamp } from '@/utils/Date'
import * as common from './utils/common.js'
import * as state from './contract.js'
import { infura_url, multicall_address, multicall_abi } from '@/constants/abis'

const providerOptions = {
    walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          rpc: {
            56: config.rpcUrl
          }
        }
    }
};


let provider;
let web3Modal;


export const notify = Notify({
  dappId: 'c68d8ec3-9b9a-4ba5-a3eb-6232eff79030',
  //9777c03e-be2e-4f99-84f9-5463fca4005d
  networkId: config.networkId,
  desktopPosition: 'topRight',
})

export function notifyHandler(hash) {
  let { emitter } = notify.hash(hash)
  emitter.on('all', transaction => ({
      onclick: () => window.open(`${config.explorerBaseUrl}${transaction.hash}`, '_blank', 'noopener, norefferer')
    })
  )
}

export function notifyNotification(message, type = 'pending') {
  let notificationObject = {
    eventCode: 'notification',
    type: type,
    message: message,
  }

  return notify.notification(notificationObject)
}

let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
export const onboard = null;

async function init(init = true, name, walletlink = false) {
    console.time('initswap')
    let default_account;
    state.contract.initializedContracts = false;
    // comment for a random push to make vercel pay attn
    console.log(window.location.href)
    if(window.location.href == 'https://v1.ellipsis.finance/') {
       window.location = 'https://ellipsis.finance'
    }
    try {
        window.web3 = new Web3(new Web3.providers.HttpProvider(config.rpcUrl));

        web3Modal = new Web3Modal({
          network: 'binance', // this is optional but walletconnect needed it to connect to BSC
          cacheProvider: true,
          theme: "dark",
          providerOptions
        });
        const externalProvider = await web3Modal.connect();
        provider = new ethers.providers.Web3Provider(externalProvider);

        const signer = await provider.getSigner();
        state.contract.web3 = window.web3;
        state.contract.signer = signer;
        state.contract.provider = provider;

        // Check if the right network is selected
        const chainId = (await provider.getNetwork()).chainId;
        if (chainId !== config.networkId) {
            state.contract.error = `Error: wrong network type. Please switch to ${config.name} mainnet.`;
            state.contract.networkIdError = `Error: wrong network type. Please switch to ${config.name} mainnet.`;
        } else {
            state.contract.error = '';
            state.contract.networkIdError = false;
            // The following was used for the hardware wallet "change accounts"
            // dropdown. We have removed those, so for now I will leave as-is.
            // but if we do add them in we will need to sort out what to do with this.
            // walletName could be determine by testing with externalProvider.
            state.contract.walletName = 'MetaMask';
            state.contract.multicall = new state.contract.web3.eth.Contract(multicall_abi, multicall_address);

            // default_account = (await ethereum.request({ method: 'eth_accounts' }))[0];
            // with ethers you can get the account like below and it works with MetaMask and
            // Trustwallet. The commented line above returned undefined for trustwallet.
            default_account = await signer.getAddress();
            console.log('default_account', default_account);
        }

        // Check whether the network is functioning properly
        if (!state.contract.networkIdError) {
            try {
                const lastBlockNumber = await provider.getBlockNumber();
                const { timestamp: lastBlockTimestamp } = await provider.getBlock(lastBlockNumber);

                // Block time is usually b/w 2 and 20s
                const isLastBlockDelayed = (getNowTimestamp() - lastBlockTimestamp) > 120;
                state.contract.networkDelayError = isLastBlockDelayed ?
                    `The ${config.name} network seems to be having issues at the moment, please check back again soon.` :
                    '';

            } catch (err) {}
        }

        state.contract.default_account = default_account;
        if(init) await state.init(name);
        state.contract.initializedContracts = true;
        console.timeEnd('initswap')
    }
    catch(err) {
        console.error(err)
    }

}

// would like to remove the ethereum here but kept while installing
// web3Modal to see the pattern
export async function changeWallets() {

    // here we are resetting some state and modals
    state.contract.default_account = '';
    if (config.blockchainId === 'ethereum') {
      await onboard.walletReset();
    }
    console.log('selectedWallet', localStorage.getItem('selectedWallet'));
    if(config.blockchainId === 'bsc') {
      web3Modal.clearCachedProvider();
      // storage.clear();
    }

    localStorage.removeItem('selectedWallet');
    state.contract.totalShare = 0;

    // here we call init again to reload all that business it has
    // going on.
    if(config.blockchainId === 'bsc') {
      await init();
    }

    if (config.blockchainId === 'ethereum') {
        await onboard.walletSelect();
        await onboard.walletCheck();
    }
}

// Detect if wallet_addEthereumChain method is available on wallet provider
export async function canAutomaticallyChangeNetwork() {
    const ERROR_CODE_METHOD_DOESNT_EXIST = -32601;

    try {
        await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [],
        });
    } catch (err) {
        if (err.code === ERROR_CODE_METHOD_DOESNT_EXIST) return false;
    }

    return true;
}

export async function changeNetwork() {
    const returnValue = await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
            chainId: `0x${config.networkId.toString(16)}`,
            chainName: config.name,
            nativeCurrency: {
                name: config.nativeCurrency.symbol,
                symbol: config.nativeCurrency.symbol,
                decimals: config.nativeCurrency.decimals,
            },
            rpcUrls: [config.rpcUrl],
            blockExplorerUrls: [config.explorerBaseUrl.root],
        }],
    });

    const isSuccess = returnValue === null;
    if (isSuccess) window.location.reload();
}

export default init;
